import { useState } from "react";
import {
  EDealRequestStatus,
  EDealRequestType,
  IMinifiedUserSchema,
} from "../../../../../../interfaces";
import {
  DealRequestLinkType,
  DealRequestStatus,
  DealRequestType,
} from "../../../../../shared/dictionary";
import Button from "../../../../../ui/button";
import Card from "../../../../../ui/card";
import CancelDealModal from "./modals/cansel/cancelDeal";
import styles from "./styles.module.scss";
import { UTCtoLocal } from "../../../../../../lib/utils";
import { LinkDealRequestsSchema } from "../../../../../../api/hooks/use-deal-list";
import useOpenModal from "../../../../../ui/modal/hooks/useOpenModal";

interface IDealCard {
  id: number;
  type: EDealRequestType;
  title: string;
  status: EDealRequestStatus;
  manager?: IMinifiedUserSchema;
  createdAt?: Date;
  link?: LinkDealRequestsSchema;
  onRefetch: () => void;
}

const DealCard = ({
  id,
  type,
  link,
  title,
  status,
  manager,
  createdAt,
  onRefetch,
}: IDealCard) => {
  const { offsetY, open, handleChangeModal } = useOpenModal();

  const connection =
    link &&
    link.dealRequestIds
      .filter((dealRequestId) => id !== dealRequestId)
      .map((requestItem) => {
        return <span>{" " + requestItem}</span>;
      });

  return (
    <div className={styles.dealCard}>
      <Card>
        <div className={styles.dealCard__container}>
          <div className={styles.dealCard__left}>
            <div className={styles.dealCard__header}>
              Заявка: <span>№{id}</span>{" "}
              <span>{UTCtoLocal(String(createdAt))}</span>
            </div>
            <div className={styles.dealCard__title}>
              Название заявки:{" "}
              <span>{`${
                link ? DealRequestLinkType.label(link.linkType) + " " : ""
              }${DealRequestType.label(type)}`}</span>
            </div>
            {link && (
              <div className={styles.dealCard__connection}>
                Связь с заявками: {connection}
              </div>
            )}
            <div className={styles.dealCard__status}>
              Статус заявки: <span>{DealRequestStatus.label(status)} </span>
            </div>
            <div className={styles.dealCard__manager}>
              Менеджер: <span>{manager?.name ?? "Не назначен"}</span>
            </div>
          </div>

          <div className={styles.dealCard__right}>
            {status !== EDealRequestStatus.Cancelled && (
              <div className={styles.dealCard__cancel}>
                <Button
                  variant="dark"
                  label="Отменить"
                  size="small"
                  onClick={() => handleChangeModal(true)}
                />
              </div>
            )}
          </div>
        </div>
      </Card>

      <CancelDealModal
        offsetY={offsetY}
        opened={open}
        onClose={(value) => handleChangeModal(value)}
        title={title}
        id={id}
        onRefetch={onRefetch}
      />
    </div>
  );
};

export default DealCard;
